import styleVars from './_vars.scss'

export const FR_PR_WHITE = styleVars.FR_PR_WHITE
export const FR_PR_BLACK = styleVars.FR_PR_BLACK
export const FR_PR_BLUE = styleVars.FR_PR_BLUE
export const FR_GREY_100 = styleVars.FR_GREY_100
export const FR_GREY_200 = styleVars.FR_GREY_200
export const FR_GREY_300 = styleVars.FR_GREY_300
export const FR_GREY_400 = styleVars.FR_GREY_400
export const FR_GREY_500 = styleVars.FR_GREY_500
export const FR_GREY_600 = styleVars.FR_GREY_600
export const FR_SP1 = styleVars.FR_SP1
export const FR_SP2 = styleVars.FR_SP2
export const FR_SP3 = styleVars.FR_SP3
export const FR_PR_PINK = styleVars.FR_PR_PINK
export const FR_PR_YELLOW = styleVars.FR_PR_YELLOW
export const FR_IL_RED = styleVars.FR_IL_RED
